import React from "react";
import PublicNavbar from "./publico/PublicNavbar";

export default function GraciasReserva() {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-green-100 min-h-screen pt-20 pb-10 overflow-x-hidden w-full">
      <PublicNavbar />
      <div className="max-w-xl mx-auto mt-20 bg-white rounded-2xl shadow-lg p-10 flex flex-col items-center">
        <svg className="w-20 h-20 text-green-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        <h1 className="text-3xl font-bold text-green-800 mb-2 text-center">¡Gracias por reservar!</h1>
        <p className="text-lg text-gray-700 text-center mb-4">Tu pago fue exitoso y tu reserva está confirmada.<br />Te esperamos en la cancha.</p>
        <a href="/" className="mt-4 px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition">Volver al inicio</a>
      </div>
    </div>
  );
}
